import React from 'react';

const CriminalTab = () => {
  return (
    <div>
      
    </div>
  );
};

CriminalTab.propTypes = {};

export default CriminalTab;
